import { useTranslation } from "react-i18next";
import { Bar } from "./ChartCanvas";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
} from "chart.js";

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
);
function generateDistinctColors(count) {
    const colors = [];
    const goldenRatio = 0.618033988749895;
    let hue = Math.random();

    for (let i = 0; i < count; i++) {
        hue += goldenRatio;
        hue %= 1;

        colors.push(`hsl(${Math.floor(hue * 360)}, 75%, 55%)`);
    }

    return colors;
}

const SalesBarChart = ({ data }) => {

    const { t } = useTranslation();

    const invoiceTypes = data?.BRANCH_SALES_TYPE?.reduce((types, branch) => {
        branch.BRANCH_SALES_TYPE.forEach(item => {
            if (!types.includes(item.INVOICE_NAME)) {
                types.push(item.INVOICE_NAME);
            }
        });
        return types;
    }, []) || [];

    const branchNames = data?.BRANCH_SALES_TYPE?.map(branch => {
        return branch.BRANCH_NAME || branch.BRANCH_SALES_TYPE[0]?.BRANCH_NAME || branch.BRANCH;
    }) || [];

    const branchSalesData = invoiceTypes.map(invoiceType => {
        return data?.BRANCH_SALES_TYPE.map(branch => {
            const branchSales = branch.BRANCH_SALES_TYPE.find(item => item.INVOICE_NAME === invoiceType);
            return branchSales ? branchSales.SALES : 0;
        });
    });
    const colors = generateDistinctColors(branchNames.length);

    const chartData = {
        labels: invoiceTypes,
        datasets: branchNames.map((branchName, index) => ({
            label: branchName,
            data: branchSalesData.map(salesData => salesData[index]),
            backgroundColor: colors[index],
            borderColor: colors[index],
            // backgroundColor: `hsl(${(index * 90) % 360}, 80%, 50%)`,
            // borderColor: `hsl(${(index * 90) % 360}, 80%, 70%)`,
            borderWidth: 1,
            barThickness: 15,
            borderRadius: 8,
        })),
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    padding: 20,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `المبيعات: ${tooltipItem.raw.toLocaleString()}`;
                    },
                },
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                titleFont: {
                    size: 18,
                },
                bodyFont: {
                    size: 16,
                },
                borderRadius: 50,
                padding: 10,
                boxPadding: 5,
                displayColors: true,
                labelColor: function (context) {
                    return {
                        borderColor: context.dataset.borderColor,
                        backgroundColor: context.dataset.borderColor,
                    };
                },
                custom: function (tooltip) {
                    tooltip.bodyFont = { size: 16 };

                    tooltip.body.forEach(function (bodyItem) {
                        bodyItem.before = `<span style="display: inline-block; width: 12px; height: 12px; border-radius: 50%; background-color: ${bodyItem.fillStyle}; margin-right: 5px; outline: none;"></span>`;
                    });
                },
            },
            title: {
                display: true,
                text: t("BRANCH_SALES_BY_SERVICE"),
                align: "end",
                position: "top",
                font: {
                    size: 18,
                    weight: "500",
                    family: "'Cairo', SemiBold",
                },
                color: "#585858"

            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                    callback: function (value) {
                        return value >= 1_000_000
                            ? `${value / 1_000_000}M`
                            : value.toLocaleString();
                    },
                    stepSize: 1_000_000,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
        },
    };

    return (
        <div className="Chart_Div">
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default SalesBarChart;
